// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import React, { Dispatch, RefObject, SetStateAction } from 'react';
import { Dayjs } from 'dayjs';

// lib files
import { filterListings } from '@/lib/helpers/multi-livestream/filterListings';
import { Channel, Listing, Theme } from '@/lib/types/api/multi-livestream'

// components
import MultiLivestreamListing from '@/components/MultiLivestream/Schedule/Listing';

// styles
import styles from '@/components/MultiLivestream/Schedule/Channel.module.scss';

interface MultiLivestreamChannelProps {
  channel: Channel;
  selectedChannel: string;
  setUserSelectedChannel: Dispatch<SetStateAction<string>>;
  scheduleTimes: Dayjs[];
  now: Dayjs;
  theme: Theme;
  ref: RefObject<HTMLDivElement | null>;
}

const MultiLivestreamChannel = (props: MultiLivestreamChannelProps) => {
  const {
    channel,
    ref,
    setUserSelectedChannel,
    selectedChannel,
    scheduleTimes,
    now,
    theme,
  } = props;
  const isSelected = selectedChannel === channel.feed_cid;
  const buttonClassName = `${styles.channel_button}${
    isSelected ? ` ${styles.channel_button__selected}` : ''
  }`;

  let channelLogo = null;

  if (theme === 'dark' && channel.feed_image?.white_logo) {
    channelLogo = `${channel.feed_image.white_logo}?resize=320x&format=webp`;
  } else if (theme === 'light' && channel.feed_image?.color_logo) {
    channelLogo = `${channel.feed_image.color_logo}?resize=320x&format=webp`;
  }

  const scheduleStart = scheduleTimes[0];
  const scheduleEnd = scheduleTimes[scheduleTimes.length - 1].add(30, 'minute');

  const filteredListings: Array<Listing> = filterListings(
    channel.listings,
    now,
    scheduleStart,
    scheduleEnd
  );

  return (
    <>
      <div
        className={styles.multi_livestream__schedule__channel}
        key={channel.short_name}
      >
        {/* Channel Buttons */}
        <div className={styles.channel_button__container}>
          <button
            className={buttonClassName}
            onClick={() => setUserSelectedChannel(channel.feed_cid)}
            key={channel.feed_cid}
          >
            {channelLogo ? (
              <img
                src={channelLogo}
                className={styles.channel_button__logo}
                alt={channel.full_name}
              />
            ) : (
              <span className={styles.channel_button__text}>{channel.full_name}</span>
            )}
          </button>
        </div>
        {/* Listings */}
        <div className={styles.multi_livestream__schedule__channel__listings} ref={ref}>
          {filteredListings.map((listing, index) => {
            return (
              <MultiLivestreamListing
                key={`${listing.show_title}-${index}`}
                listing={listing}
                listingIndex={index}
                channelCid={channel.feed_cid}
                channelIsSelected={isSelected}
                channelLogo={channelLogo!}
                channelTitle={channel.full_name}
                setUserSelectedChannel={setUserSelectedChannel}
                now={now}
                scheduleStart={scheduleStart}
                scheduleEnd={scheduleEnd}
                theme={theme}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MultiLivestreamChannel;
